// Landing.jsx
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ModalView from '../container/ModalView.js';
import LandingContent from '../container/LandingContent.js';

import { getIsInIframe } from '../resource/getJsEnvironment.js';
import { ModalId } from '../resource/mixpanel.js';
import { getIsGoogleBot } from '../resource/getUserAgent.js';
import { unmountInitialCover } from '../resource/initialCover.js';

const isInIframe = getIsInIframe();
const isGoogleBot = getIsGoogleBot();

export class Landing extends Component {
  componentDidMount() {
    this.handleModal();
  }
  componentDidUpdate({
    token: prevToken,
    isRemoteConfigMerged: prevMerged,
    shouldVerifyAge: prevShouldVerifyAge,
    isInNeedLandingCountries: prevIsInNeedLandingCountries,
  }) {
    const {
      token,
      isRemoteConfigMerged,
      shouldVerifyAge,
      isInNeedLandingCountries,
    } = this.props;
    if (
      (token && token !== !prevToken) ||
      (isRemoteConfigMerged && isRemoteConfigMerged !== prevMerged) ||
      shouldVerifyAge !== prevShouldVerifyAge ||
      isInNeedLandingCountries !== prevIsInNeedLandingCountries
    ) {
      this.handleModal();
    }
  }
  componentWillUnmount() {
    this.handleClose();
  }
  handleModal() {
    const {
      token,
      isInNeedLandingCountries,
      isDisplaying,
      isRemoteConfigMerged,
      shouldVerifyAge,
    } = this.props;

    const shouldAlwaysClose = token || isInIframe || isGoogleBot;
    if (shouldAlwaysClose) {
      if (isDisplaying) {
        this.handleClose();
      }
      // unmount initial cover when having token or iframe or google bot
      unmountInitialCover();
      return;
    }

    if (!isRemoteConfigMerged) {
      return;
    }

    const shouldDisplay = shouldVerifyAge && isInNeedLandingCountries;
    if (shouldDisplay && !isDisplaying) {
      this.handleOpen();
    } else if (isDisplaying && !shouldDisplay) {
      this.handleClose();
    }

    // unmount initial cover when in need landing countries and no need to verify age (e.g. when using utm query params)
    if (isInNeedLandingCountries && !shouldVerifyAge) {
      unmountInitialCover();
    }
  }
  handleOpen() {
    this.props.open();
    document.body.style.overflow = 'hidden';
  }
  handleClose() {
    document.body.style.overflow = 'auto';
    this.props.close();
    // unmount initial cover when landing modal is closed
    unmountInitialCover();
  }
  render() {
    return (
      <ModalView
        id="LandingPageModal"
        modalId={ModalId.Landing.LandingPage2024Iwin}
        render={() => <LandingContent />}
      />
    );
  }
}

Landing.propTypes = {
  token: PropTypes.string,
  shouldVerifyAge: PropTypes.bool,
  isInNeedLandingCountries: PropTypes.bool,
  isDisplaying: PropTypes.bool,
  open: PropTypes.func,
  close: PropTypes.func,
  isRemoteConfigMerged: PropTypes.bool,
};

Landing.defaultProps = {
  token: '',
  shouldVerifyAge: false,
  isInNeedLandingCountries: false,
  isDisplaying: false,
  open: () => null,
  close: () => null,
  isRemoteConfigMerged: false,
};

export default Landing;
